module.exports = __webpack_public_path__ + "static/img/my_add.f73e417.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/my_add.png
// module id = Zd72
// module chunks = 1